var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlternative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62098 0.378346L15.8299 12.8649C15.8963 12.9799 15.9313 13.1104 15.9313 13.2432C15.9313 13.3761 15.8963 13.5066 15.8299 13.6216C15.7635 13.7367 15.6679 13.8322 15.5529 13.8986C15.4379 13.965 15.3074 14 15.1745 14H0.75674C0.623903 14 0.493406 13.965 0.378367 13.8986C0.263328 13.8322 0.167799 13.7367 0.101382 13.6216C0.0349645 13.5066 -8.43659e-07 13.3761 0 13.2432C8.43689e-07 13.1104 0.0349678 12.9799 0.101386 12.8649L7.31028 0.378346C7.3767 0.263313 7.47223 0.16779 7.58727 0.101377C7.7023 0.0349634 7.8328 0 7.96563 0C8.09846 0 8.22895 0.0349634 8.34399 0.101377C8.45903 0.16779 8.55456 0.263313 8.62098 0.378346ZM2.06745 12.4865H13.8638L7.96639 2.27024L2.06745 12.4865ZM7.20887 10.2162H8.72239V11.7297H7.20887V10.2162ZM7.20887 4.9189H8.72239V8.7027H7.20887V4.9189Z",
    fill: "#62666C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlternative);
export default __webpack_public_path__ + "static/media/WarningAlternative.954c2fe85c7eb7c372265d3968ad1bc2.svg";
export { ForwardRef as ReactComponent };